module.exports = __webpack_public_path__ + "assets/img/banner02_m.ad5c509b.png";